import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { SpecificationRepository } from "@partikelart/specification/data-access-core";
import { Specification } from "@partikelart/specification/domain";
import { CreateSpecificationDto, UpdateSpecificationDto } from "@partikelart/specification/dtos";
import { Observable } from "rxjs";
import { CLOUD_SPECIFICATION_API_CONFIG } from "./cloud-specification-api-config.token";

@Injectable({
	providedIn: "root",
})
export class CloudSpecificationRepository implements SpecificationRepository {
	private readonly http = inject(HttpClient);
	private readonly config = inject(CLOUD_SPECIFICATION_API_CONFIG, { optional: true });

	private get baseUrl(): string {
		return `${this.config?.portalBackendUrl ?? "http://localhost:3000"}/api`;
	}

	getSpecifications(siteId?: string, active?: boolean): Observable<Specification[]> {
		let params = new HttpParams();
		if (siteId) params = params.set("siteId", siteId);
		if (active !== undefined) params = params.set("active", String(active));
		return this.http.get<Specification[]>(`${this.baseUrl}/specifications`, { params });
	}

	getSpecification(id: string): Observable<Specification> {
		return this.http.get<Specification>(`${this.baseUrl}/specifications/entity/${id}`);
	}

	createSpecification(dto: CreateSpecificationDto): Observable<Specification> {
		return this.http.post<Specification>(`${this.baseUrl}/specifications`, dto);
	}

	updateSpecification(id: string, dto: UpdateSpecificationDto): Observable<Specification> {
		return this.http.put<Specification>(`${this.baseUrl}/specifications/${id}`, dto);
	}

	deleteSpecification(id: string): Observable<void> {
		return this.http.delete<void>(`${this.baseUrl}/specifications/${id}`);
	}
}
